module.exports = __webpack_public_path__ + "img/2p-zh.b1bc29f7.png";